// extracted by mini-css-extract-plugin
export default {"root":"info-table_root__k-Yld","valueDescription":"info-table_valueDescription__50N8t"};